import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MultiModalComponentData } from '@whelk/const';

interface UploadState {
  files: Array<MultiModalComponentData>;
  uploadStatusInfo: Record<string, { progress: number; status: string; cpt: any }>;
  error: string | null;
  uploadStatus: '' | 'uploading' | 'done' | 'retry';
}

const initialState: UploadState = {
  files: [],
  uploadStatusInfo: {},
  uploadStatus: '',
  error: null,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    addFile(state, action: PayloadAction<MultiModalComponentData>) {
      // files 去重
      if (!action.payload || !action?.payload?.uuid) return;
      const files = state.files;

      const file = files.find((file) => file.uuid === action.payload.uuid);
      state.uploadStatusInfo[action.payload.uuid] = {
        progress: 0,
        status: 'uploading',
        cpt: undefined,
      };
      state.uploadStatus = 'uploading';
      if (!file) {
        state.files.push(action.payload);
      }
    },
    setFiles(state, action: PayloadAction<MultiModalComponentData[]>) {
      state.files = action.payload;
    },
    clearFiles(state) {
      state.files = [];
      state.uploadStatus = '';
      state.uploadStatusInfo = {};
    },
    removeFile(state, action: PayloadAction<string>) {
      const files = state.files.filter((file) => file.uuid !== action.payload);
      const isAllDone = Object.values(state.uploadStatusInfo).every(
        (item) => item.status === 'done',
      );
      state.uploadStatus = isAllDone ? 'done' : state.uploadStatus;
      if (!files.length) {
        state.uploadStatus = '';
      }
      delete state.uploadStatusInfo[action.payload];
      state.files = files;
    },
    // updateProgress(state, action: PayloadAction<{ uuid: string; progress: number; cpt: any }>) {
    //   const { uuid, progress, cpt } = action.payload;

    //   // 使用Immer来更新状态
    //   if (!state.uploadStatus[uuid]) {
    //     state.uploadStatus[uuid] = { progress: 0, cpt: null, status: 'uploading' };
    //   }

    //   state.uploadStatus[uuid].progress = progress;
    //   state.uploadStatus[uuid].cpt = cpt;
    // },
    updateStatus(state, action: PayloadAction<{ uuid: string; status: string }>) {
      // 如果uuid不存在files内，说明已经被删除
      if (state.files.findIndex((item) => item.uuid === action.payload.uuid) < 0) return;

      state.uploadStatusInfo[action.payload.uuid].status = action.payload?.status;
      if (action.payload.status === 'retry') {
        state.uploadStatus = 'retry';
        state.uploadStatusInfo[action.payload.uuid].cpt = undefined;
      } else if (action.payload.status === 'done') {
        state.uploadStatus = Object.values(state.uploadStatusInfo).every(
          (item) => item.status === 'done',
        )
          ? 'done'
          : state.uploadStatus;
        state.uploadStatusInfo[action.payload.uuid].progress = 100;
      }
    },
    updateFileInfo(
      state,
      action: PayloadAction<{ uuid: string; fileID: string; ossPath?: string }>,
    ) {
      const files = state.files;
      const file = files.find((file) => file.uuid === action.payload.uuid);
      if (file) {
        file.fileID = String(action.payload.fileID);
        file.ossPath = String(action.payload?.ossPath);
      }
      state.files = files;
    },
  },
});

export const { addFile, removeFile, updateStatus, setFiles, updateFileInfo, clearFiles } =
  uploadSlice.actions;
export default uploadSlice.reducer;
